<template>
    <div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i
            ><span
                >{{ $t("app.links.budget_requests") }}
                <budget-forms-list :curFormSelect="'/form01-123'" />
            </span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
            ></forms-download-reprt>
        </div>

        <div class="filter-container">
            <div class="left-content">
                <p v-if="!categoryMode" class="title">
                    {{ getCommonText("decoding") }}. {{ currCategoryLabel }}
                </p>
            </div>
            <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="
                        categoryMode &&
                        !isGkkpMode &&
                        !(progress < 100) &&
                        variantAttribute
                    "
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadCategoryData"
                />
                <div class="filter-actions filter-actions-flex">
                    <template v-if="categoryMode">
                        <c-budget-forms-copy-data
                            v-if="
                                !(progress < 100) &&
                                variantAttribute &&
                                header.year < header.cur_year + 2
                            "
                            :budgetForm="budgetForm"
                            :header="header"
                            :isLoad="isLoad"
                            @keyPress="keyPress"
                        />
                        <b-button
                            variant="primary"
                            @click="addItem"
                            v-if="variantAttribute"
                            :disabled="isLoad || !lastRowFilled || hasDuplicateGroups"
                            ><i class="icon icon-plus-circle"></i>
                            {{ getCommonText("add") }}</b-button
                        >
                    </template>
                    <template v-else>
                        <b-button variant="light" @click="resetModal" :style="{ minWidth: '170px' }">
                            <i class="icon icon-keyboard icon-rotate-180"></i>
                            {{ getCommonText("back_to_list") }}
                        </b-button>
                        <b-button
                            :style="{ minWidth: '110px' }"
                            v-if="variantAttribute"
                            variant="primary"
                            :disabled="hasDecodeControlViolation"
                            @click="$refs.formTemplate.addItem()"
                        >
                            <i class="icon icon-plus-circle"></i
                            >{{ getCommonText("add") }}
                        </b-button>
                        <b-button
                            :style="{ minWidth: '110px' }"
                            :disabled="!dataChanged || isLoad || hasDecodeControlViolation"
                            variant="success"
                            @click="prepareForSaveDecodes"
                        >
                            {{ getCommonText("save") }}
                        </b-button>
                    </template>
                </div>
            </div>
        </div>

        <div v-show="categoryMode" class="table-container">
            <b-overlay :show="isLoad" rounded="sm">
                <b-table
                    :items="displayedGroups"
                    :fields="tableFields"
                    presponsive="true"
                    bordered
                    head-variant="light"
                    sticky-header="true"
                    no-border-collapse
                >
                    <template #top-row="data">
                        <td class="td-numbering"></td>
                        <td class="td-numbering"></td>
                        <td class="td-numbering table-success">1</td>
                        <td class="td-numbering table-danger">2</td>
                        <td class="td-numbering table-info">3</td>
                        <td class="td-numbering table-primary">4</td>
                        <td class="td-numbering table-warning">5</td>
                        <td class="td-numbering table-success">6</td>
                        <td class="td-numbering table-danger">7</td>
                        <td class="td-numbering table-info">8</td>
                        <td class="td-numbering table-primary">9</td>
                        <td class="td-numbering table-warning">10</td>
                        <td class="td-numbering"></td>
                    </template>
                    <template #head(selection)>
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="selectAll"
                                @change="(val) => setIsAllDelete(val, displayedGroups)"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #cell(selection)="data">
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="data.item.itemToDelete"
                                @input="(e) => { if (!e) selectAll = false; }"
                                :value="true"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #cell(action)="data">
                        <div class="text-center">
                            <button
                                class="table-plus"
                                :class="{ 'table-plus-disabled': isDecodeBtnDisabled(data.item) }"
                                @click="openDecode(data.item)"
                            >
                                <i class="icon icon-plus-circle" />
                            </button>
                        </div>
                    </template>
                    <template #cell(post)="data">
                        <div class="error">
                            <multiselect
                                v-if="variantAttribute && !isGroupLocked(data.item)"
                                style="width: 260px"
                                :custom-label="postLabel"
                                track-by="code"
                                v-model="data.item.postObj"
                                :title="postLabel(data.item.postObj)"
                                :placeholder="getFormText('select_post')"
                                :options="selectableDictPost"
                                @input="(e) => onChangeGroupField(data.item, 'post', e)"
                            ></multiselect>
                            <div v-else>{{ postLabel(data.item.postObj) }}</div>
                            <span v-if="data.item.checkForDuplicates" class="dup-hint">
                                <i class="icon icon-danger decodes-error-icon"></i>
                                <div class="pop-up">
                                    <p class="red-text">{{ getCommonText("not_valid") }}</p>
                                    <p>{{ getCommonText("exist") }}</p>
                                </div>
                            </span>
                        </div>
                    </template>
                    <template #cell(local_category)="data">
                        <multiselect
                            v-if="variantAttribute && !isGroupLocked(data.item)"
                            style="width: 260px"
                            :custom-label="localCategoryLabel"
                            track-by="code"
                            v-model="data.item.localCategoryObj"
                            :title="localCategoryLabel(data.item.localCategoryObj)"
                            :placeholder="getFormText('select_local_category')"
                            :options="selectableDictLocalCategory"
                            @input="(e) => onChangeGroupField(data.item, 'local_category', e)"
                        ></multiselect>
                        <div v-else>{{ localCategoryLabel(data.item.localCategoryObj) }}</div>
                    </template>
                    <template #cell(daily_norm)="data">
                        <div class="text-right">{{ $n(data.item.daily_norm) }}</div>
                    </template>
                    <template #cell(housing_norm)="data">
                        <div class="text-right">{{ $n(data.item.housing_norm) }}</div>
                    </template>
                    <template #cell(avg_daily_people_days)="data">
                        <div class="text-right">{{ $n(data.item.avg_daily_people_days) }}</div>
                    </template>
                    <template #cell(avg_housing_people_days)="data">
                        <div class="text-right">{{ $n(data.item.avg_housing_people_days) }}</div>
                    </template>
                    <template #cell(avg_trip_count)="data">
                        <div class="text-right">{{ $n(data.item.avg_trip_count) }}</div>
                    </template>
                    <template #cell(avg_transp_cost)="data">
                        <div class="text-right">{{ $n(data.item.avg_transp_cost) }}</div>
                    </template>
                    <template #cell(total_thousand_tenge)="data">
                        <div class="text-right">{{ $n(data.item.total_thousand_tenge) }}</div>
                    </template>
                    <template #cell(files)="data">
                        <span
                            class="blue pointer underline"
                            @click="onAllFilesClick(data.item)"
                            >({{ data.item.files ? data.item.files.length : 0 }})</span
                        >
                    </template>
                    <template #head(more)>
                        <div class="text-center">
                            <i
                                v-if="variantAttribute"
                                :title="getCommonText('del_selected')"
                                class="icon icon-close table-all-remove"
                                @click="deleteSelectedGroups"
                            ></i>
                        </div>
                    </template>
                    <template #cell(more)="data">
                        <i
                            v-if="variantAttribute"
                            class="icon icon-clear table-remove"
                            @click="deleteGroup(data.item)"
                        ></i>
                    </template>
                    <template #bottom-row>
                        <td colspan="10" class="text-right">{{ getCommonText("total") }}</td>
                        <td class="text-right">{{ $n(totalThousandTenge) }}</td>
                        <td colspan="2"></td>
                    </template>
                </b-table>
                <div class="table-add" v-if="variantAttribute" :disabled="isLoad || !lastRowFilled || hasDuplicateGroups">
                    <span @click="addItem" :class="{ 'disabled-link': !lastRowFilled || hasDuplicateGroups }"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</span>
                </div>
            </b-overlay>
        </div>

        <template v-if="!categoryMode">
            <b-overlay :show="isLoad" rounded="sm">
                <form-template14
                    ref="formTemplate"
                    :goodsData="goodsData"
                    :variantAttribute="variantAttribute"
                    :header="header"
                    :currCategory="currCategory"
                    :lng="lng"
                    :isLoad="isLoad"
                    :isEndDateInvalid="isEndDateInvalid"
                    :isRentOverLimit="isRentOverLimit"
                    :rentLimitAmount="rentLimitAmount"
                    :limitTengeAmount="limitTengeAmount"
                    :checkDecodeControls="checkDecodeControls"
                    :decodeLabel="decodeLabel"
                    :setDataChanged="setDataChanged"
                    :deleteDecodeRow="deleteDecodeRow"
                    :deleteDecodeRows="deleteDecodeRows"
                    :showGoalModal="showGoalModal"
                    :allFiles="allFiles"
                    :showFileUploadModal="showFileUploadModal"
                    :triggDownloadFile="triggDownloadFile"
                    :triggDownloadAllFiles="triggDownloadAllFiles"
                    :safeDecimal="safeDecimal"
                    :makeToast="makeToast"
                    @addGetParams="addGetParams"
                ></form-template14>
                <div class="table-add" v-if="variantAttribute">
                    <span
                        @click="$refs.formTemplate.addItem()"
                        :class="{ 'disabled-link': hasDecodeControlViolation }"
                        ><i class="icon icon-plus-circle"></i>
                        {{ getCommonText("add") }}</span
                    >
                </div>
            </b-overlay>
        </template>
        <files-updown
            v-if="isFilterReady"
            ref="filesUpdown"
            v-show="categoryMode"
            :header="header"
            :variant-attribute="variantAttribute"
            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
            :load="isLoad"
            :showDeleteLinks="variantAttribute"
            :showDeleteAll="true"
            @fillFilesList="onNewFileUploaded"
            @delelteAttachedFile="delelteAttachedFile"
            @restetFilesList="restetFilesList"
            @onFilePreview="onFilePreview"
        ></files-updown>
        <modal-all-files-management
            ref="modalAllFilesManagement"
            :allFiles="allFiles"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
        >
        </modal-all-files-management>
        <c-set-b-f-category-name
            ref="setGoalModal"
            :budgetForm="goodsData"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'goal_ru', kk: 'goal_kk' }"
            :maxNameLengthSymbls="500"
            :title="getFormText('goal_title')"
            :textareaTitleRu="getFormText('goal_textarea_title_ru')"
            :textareaTitleKk="getFormText('goal_textarea_title_kk')"
            :placeHolder="getFormText('goal_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="onGoalChanged"
        />
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import FilesUpdown from "@/modules/budget-request/FilesUpdown";
import BudgetFormsList from "@/modules/budget-request/components/budget-forms-list.vue";
import FormsHandlerMixin from "@/modules/budget-request/mixins/forms-handler-mixin";
import ModalAllFilesManagement from "@/modules/budget-request/components/modal-all-files-management.vue";
import FormsDownloadReprt from "@/modules/budget-request/components/forms-download-reprt.vue";
import CSetBFCategoryName from "./components/c-set-bf-category-name.vue";
import FormTemplate14 from "./components/budget-forms-template14.vue";
import CBudgetFormsCopyData from './components/budget-forms-copy-data.vue';
import CBudgetFormsDataTransfer from './components/budget-forms-data-transfer.vue';
import { Ax } from '@/utils';

export default {
    name: "Form01_161_v2",
    components: {
        FilesUpdown,
        BudgetFormsList,
        FormTemplate14,
        FormsDownloadReprt,
        ModalAllFilesManagement,
        CSetBFCategoryName,
        CBudgetFormsDataTransfer,
        CBudgetFormsCopyData
    },
    mixins: [FormsHandlerMixin],
    data() {
        return {
            form: {
                code: "01-161",
                version: 2,
                name_ru: "Расчет расходов на служебные командировки внутри страны",
                name_kk: "Ел iшiндегi қызметтiк iссапарларға арналған шығыстарды есептеу",
            },
            variantAttribute: null,
            openDisabled: false,
            budgetForm: [],
            pendingGroups: [],
            header: null,
            isLoad: false,
            dictPost: [],
            dictLocalCategory: [],
            mrp: 0,
            newRowStartId: -1,
            selectAll: false,
            postDecodeRows: [],
        };
    },
    created() {
        this.$emit("setForm", this.form);
    },
    mounted() {
        this.progress = 15;
    },
    watch: {
        categoryMode() {
            this.$emit("setCategoryMode", this.categoryMode);
        },
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        },
        goodsData: {
            handler() {
                const hasDataToSave = this.goodsData.some((gd) => gd.rowToSave);
                this.setDataChanged(hasDataToSave);
            },
            deep: true,
        },
    },
    methods: {
        postLabel(obj) {
            return obj ? obj["name_" + this.lng] || obj.name_ru : "";
        },

        localCategoryLabel(obj) {
            if (!obj) return "";
            return this.lng === "kk" ? obj.name_kz : obj.name_ru;
        },

        decodeLabel(post, localCategory) {
            const postObj = this.dictPost.find((p) => p.code === post);
            const catObj = this.dictLocalCategory.find((c) => c.code === localCategory);
            return `${this.postLabel(postObj)}. ${this.localCategoryLabel(catObj)}`;
        },

        buildKatoFullPath(path) {
            const nameField = this.lng === "kk" ? "name_kz" : "name_ru";
            if (path && path.length) {
                return path.map((p) => p[nameField] || p.name_ru).join(" → ");
            }
            return "";
        },

        downloadRep(fileType) {
            this.isReportUploading = true;
            const newHeader = {
                ...this.header,
                lang: this.$i18n.locale,
                code_modules: this.moduleCode,
                output_file_type: fileType
            };
            Ax(
                {
                    url: '/api-py/budg_' + this.form.code.replace('-', '_') + '/1/' + JSON.stringify(newHeader),
                    method: 'POST',
                    responseType: 'blob'
                },
                async (data) => {
                    if (data.type === 'application/json') {
                        const text = await data.text();
                        const result = JSON.parse(text);
                        if ('error' in result && 'message' in result) {
                            this.makeToast('danger', 'Ошибка получения файла', `${result.error} - ${result.message}`);
                        }
                    } else {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `${this.getCommonText('form')} ${this.form.code.replace('-', '_')}.${fileType}`);
                        document.body.appendChild(link);
                        link.click();
                    }
                    this.isReportUploading = false;
                },
                (error) => {
                    this.isReportUploading = false;
                    this.makeToast('danger', `${this.getErrText('bad_request')} downloadRep()`, error.toString());
                }
            );
        },

        async loadDict() {
            this.$set(this.header, "form_version", this.form.code + "_v2");
            await Promise.all([
                this.loadDictTripPosition(),
                this.loadDictLocalCategory(),
                this.loadMrp(),
            ]);
        },

        async loadDictTripPosition() {
            try {
                const response = await fetch(
                    `/api-py/get-dict-trip-position/${this.header.form}/${this.header.variant_date_time}/`
                );
                if (response.ok) {
                    const items = await response.json();
                    this.dictPost = items;
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadDictTripPosition()`,
                    error.toString()
                );
            }
        },

        async loadDictLocalCategory() {
            try {
                const response = await fetch(
                    `/api-py/get-dict-local-category/${this.header.variant_date_time}/`
                );
                if (response.ok) {
                    const items = await response.json();
                    this.dictLocalCategory = items;
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadDictLocalCategory()`,
                    error.toString()
                );
            }
        },

        async loadMrp() {
            this.mrp = 0;
            try {
                const response = await fetch(
                    `/api-py/dictionary-normative-inds/${this.header.year}/${this.header.cur_year}/${this.header.variant_date_time}`
                );
                if (response.ok) {
                    const items = await response.json();
                    const mrpRow = items.find((row) => row.code === "MRP");
                    if (mrpRow) this.mrp = parseFloat(mrpRow.value);
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadMrp()`,
                    error.toString()
                );
            }
        },

        async loadCategoryData() {
            this.selectAll = false;
            this.isLoad = true;
            this.budgetForm.splice(0);
            this.pendingGroups.splice(0);
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-01-161-v2-main/",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json;charset=utf-8" },
                        body: JSON.stringify(this.header),
                    }
                );
                if (response.ok) {
                    const values = await response.json();
                    values.forEach((val, index) => {
                        const item = { ...val };
                        this.$set(item, "id", index);
                        this.$set(item, "rowKey", `${val.post}_${val.local_category}`);
                        this.$set(item, "postObj", this.dictPost.find((p) => p.code === val.post) || null);
                        this.$set(
                            item,
                            "localCategoryObj",
                            this.dictLocalCategory.find((c) => c.code === val.local_category) || null
                        );
                        this.$set(item, "files", this.getUnicFilesArr(val));
                        this.$set(item, "checkForDuplicates", false);
                        this.$set(item, "itemToDelete", false);
                        this.budgetForm.push(item);
                    });
                    this.pendingGroups = this.pendingGroups.filter(
                        (pg) =>
                            !this.budgetForm.some(
                                (bf) => bf.post === pg.post && bf.local_category === pg.local_category
                            )
                    );
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadCategoryData()`,
                    error.toString()
                );
            }
            this.isLoad = false;
        },

        addItem() {
            if (this.isLoad || !this.lastRowFilled || this.hasDuplicateGroups) return;
            const item = { id: this.newRowStartId, rowKey: `new_${this.newRowStartId}` };
            this.newRowStartId--;
            this.$set(item, "post", null);
            this.$set(item, "local_category", null);
            this.$set(item, "postObj", null);
            this.$set(item, "localCategoryObj", null);
            this.$set(item, "limit", null);
            this.$set(item, "daily_norm", this.dailyNormValue.toNumber());
            this.$set(item, "housing_norm", 0);
            this.$set(item, "avg_daily_people_days", 0);
            this.$set(item, "avg_housing_people_days", 0);
            this.$set(item, "avg_trip_count", 0);
            this.$set(item, "avg_transp_cost", 0);
            this.$set(item, "total_thousand_tenge", 0);
            this.$set(item, "rows_count", 0);
            this.$set(item, "files", []);
            this.$set(item, "checkForDuplicates", false);
            this.$set(item, "itemToDelete", false);
            this.pendingGroups.push(item);
        },

        async onChangeGroupField(row, field, val) {
            this.$set(row, field, val ? val.code : null);
            this.checkGroupDuplicates();
            if (row.post && row.local_category) {
                await this.loadHousingLimit(row);
            }
        },

        checkGroupDuplicates() {
            const groups = this.displayedGroups;
            const seen = new Map();
            groups.forEach((item, idx) => {
                if (!item.post || !item.local_category) {
                    this.$set(item, "checkForDuplicates", false);
                    return;
                }
                const key = `${item.post}_${item.local_category}`;
                if (seen.has(key)) {
                    this.$set(groups[seen.get(key)], "checkForDuplicates", true);
                    this.$set(item, "checkForDuplicates", true);
                } else {
                    this.$set(item, "checkForDuplicates", false);
                    seen.set(key, idx);
                }
            });
        },

        async loadHousingLimit(row) {
            try {
                const response = await fetch(
                    "/api-py/get-housing-expense-limit/",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json;charset=utf-8" },
                        body: JSON.stringify({
                            post: row.post,
                            local_category: row.local_category,
                            variant_date_time: this.header.variant_date_time,
                        }),
                    }
                );
                if (response.ok) {
                    const result = await response.json();
                    this.$set(row, "limit", result.limit_mrp);
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadHousingLimit()`,
                    error.toString()
                );
            }
        },

        isDecodeBtnDisabled(row) {
            return !(row.post && row.local_category) || row.checkForDuplicates;
        },

        isGroupLocked(row) {
            return row.rows_count > 0;
        },

        openDecode(row) {
            if (this.isDecodeBtnDisabled(row)) return;
            this.currCategory = row;
            this.categoryMode = false;
            this.loadGoodsData(row);
        },

        onBackToList() {
            if (this.dataChanged) {
                this.onGoodsModalClose();
            } else {
                this.categoryMode = true;
                this.goodsData.splice(0);
                this.postDecodeRows = [];
                this.loadCategoryData();
            }
        },

        async deleteGroup(row) {
            if (!this.variantAttribute || this.isLoad) return;
            if (!row.rows_count) {
                const idx = this.pendingGroups.findIndex((pg) => pg.rowKey === row.rowKey);
                if (idx !== -1) this.pendingGroups.splice(idx, 1);
                this.checkGroupDuplicates();
                return;
            }
            this.deleteGroups([row], this.getCommonText("curr_cat"));
        },

        async deleteGroups(rows, msg) {
            return this.$bvModal
                .msgBoxConfirm(this.getCommonText("del_with_decodes", { msg }), {
                    title: this.getCommonText("confirm"),
                    size: "lg",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: this.getCommonText("yes"),
                    cancelTitle: this.getCommonText("cancel"),
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(async (value) => {
                    if (!value) return;
                    this.isLoad = true;
                    try {
                        const idsByGroup = await Promise.all(rows.map((row) => this.fetchGroupDecodeIds(row)));
                        const ids = idsByGroup.flat();
                        if (ids.length) await this.deleteDecodeIds(ids);
                        await this.loadCategoryData();
                    } catch (error) {
                        this.makeToast("danger", this.getErrText("warning"), error.toString());
                    } finally {
                        this.isLoad = false;
                    }
                })
                .catch((error) => {
                    this.makeToast("danger", this.getErrText("on_del"), error.toString());
                });
        },

        async fetchGroupDecodeIds(row) {
            const response = await fetch("/api-py/get-budget-request-form-01-161-v2-goods/", {
                method: "POST",
                headers: { "Content-Type": "application/json;charset=utf-8" },
                body: JSON.stringify({
                    header: this.header,
                    post: row.post,
                    local_category: row.local_category,
                }),
            });
            const rows = response.ok ? await response.json() : [];
            return rows.map((r) => r.id).filter((id) => id > 0);
        },

        async deleteSelectedGroups() {
            if (!this.variantAttribute || this.isLoad) return;
            const selected = this.displayedGroups.filter((g) => g.itemToDelete);
            if (!selected.length) return;
            const pendingToDelete = selected.filter((g) => !g.rows_count);
            pendingToDelete.forEach((pg) => {
                const idx = this.pendingGroups.findIndex((p) => p.rowKey === pg.rowKey);
                if (idx !== -1) this.pendingGroups.splice(idx, 1);
            });
            const savedToDelete = selected.filter((g) => g.rows_count > 0);
            if (!savedToDelete.length) {
                this.checkGroupDuplicates();
                this.selectAll = false;
                return;
            }
            const msg = this.selectAll ? this.getCommonText("all_cats") : this.getCommonText("selected_cats");
            await this.deleteGroups(savedToDelete, msg);
            this.selectAll = false;
        },

        async loadGoodsData(cat) {
            this.isLoad = true;
            this.initialGoodsData = {};
            try {
                const [response] = await Promise.all([
                    fetch(
                        "/api-py/get-budget-request-form-01-161-v2-goods/",
                        {
                            method: "POST",
                            headers: { "Content-Type": "application/json;charset=utf-8" },
                            body: JSON.stringify({
                                header: this.header,
                                post: cat.post,
                                local_category: cat.local_category,
                            }),
                        }
                    ),
                    this.loadPostDecodeRows(cat.post),
                    this.variantAttribute ? this.loadHousingLimit(cat) : null,
                ]);
                if (response.ok) {
                    const values = await response.json();
                    values.forEach((val) => {
                        this.$set(val, "isNew", false);
                        this.$set(val, "rowToSave", false);
                        this.$set(val, "itemToDelete", false);
                        this.$set(val, "isHasDouble", false);
                        this.addGetParams(val);
                        const katoName = this.lng === "kk" ? val.kato_name_kz : val.kato_name_ru;
                        this.$set(val, "katoLabel", katoName || val.kato_name_ru || "");
                        this.$set(val, "katoSearch", katoName || val.kato_name_ru || "");
                        const katoFullPath = this.buildKatoFullPath(val.kato_path);
                        this.$set(val, "katoFullPath", katoFullPath || katoName || val.kato_name_ru || "");
                        this.initialGoodsData[val.id] = { ...val };
                    });
                    this.goodsData = values;
                    this.$nextTick(() => {
                        this.checkDecodeControls();
                    });
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadGoodsData()`,
                    error.toString()
                );
            }
            this.isLoad = false;
        },

        async loadPostDecodeRows(post) {
            this.postDecodeRows = [];
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-01-161-v2-post-rows/",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json;charset=utf-8" },
                        body: JSON.stringify({ header: this.header, post }),
                    }
                );
                if (response.ok) {
                    const items = await response.json();
                    this.postDecodeRows = items.filter(
                        (row) => row.local_category !== this.currCategory.local_category
                    );
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadPostDecodeRows()`,
                    error.toString()
                );
            }
        },

        addGetParams(item) {
            Object.defineProperty(item, "daily_days", {
                get: () => this.calcDailyDays(item),
            });
            Object.defineProperty(item, "housing_days", {
                get: () => this.calcHousingDays(item),
            });
            Object.defineProperty(item, "daily_expense", {
                get: () => this.safeDecimal(this.calcDailyDays(item)).mul(this.dailyNormValue).toDecimalPlaces(2).toNumber(),
            });
            Object.defineProperty(item, "total_expense", {
                get: () =>
                    this.safeDecimal(item.daily_expense)
                        .add(this.safeDecimal(item.rent_expense))
                        .add(this.safeDecimal(item.transp_expense))
                        .toDecimalPlaces(2)
                        .toNumber(),
            });
        },

        calcDailyDays(item) {
            if (!item.trip_start_date || !item.trip_end_date) return 0;
            const diff = this.dateDiffDays(item.trip_start_date, item.trip_end_date);
            return diff >= 0 ? diff + 1 : 0;
        },

        calcHousingDays(item) {
            if (!item.trip_start_date || !item.trip_end_date) return 0;
            const diff = this.dateDiffDays(item.trip_start_date, item.trip_end_date);
            return diff >= 0 ? diff : 0;
        },

        dateDiffDays(start, end) {
            const startD = new Date(start);
            const endD = new Date(end);
            return Math.round((endD - startD) / (1000 * 60 * 60 * 24));
        },

        isEndDateInvalid(row) {
            return !!(row.trip_start_date && row.trip_end_date && row.trip_end_date < row.trip_start_date);
        },

        normalizePers(name) {
            return (name || "").trim().toLowerCase();
        },

        checkDecodeControls() {
            this.goodsData.forEach((item) => {
                this.$set(item, "isHasDouble", false);
                this.$set(item, "dupConflicts", []);
                this.$set(item, "isHasOverlap", false);
                this.$set(item, "overlapConflicts", []);
            });

            const candidates = [];
            this.goodsData.forEach((item) => {
                if (!item.name_pers || !item.trip_start_date || !item.trip_end_date) return;
                candidates.push({
                    namePers: this.normalizePers(item.name_pers),
                    kato: item.kato,
                    katoNameRu: item.kato_name_ru,
                    katoNameKz: item.kato_name_kz,
                    start: item.trip_start_date,
                    end: item.trip_end_date,
                    localCategory: null,
                    ref: item,
                });
            });
            this.postDecodeRows.forEach((row) => {
                candidates.push({
                    namePers: this.normalizePers(row.name_pers),
                    kato: row.kato,
                    katoNameRu: row.kato_name_ru,
                    katoNameKz: row.kato_name_kz,
                    start: row.trip_start_date,
                    end: row.trip_end_date,
                    localCategory: row.local_category,
                    ref: null,
                });
            });

            this.checkDecodeDuplicates(candidates);
            this.checkDecodeOverlaps(candidates);

            this.goodsData.forEach((item) => {
                this.$set(item, "dupConflicts", this.dedupeConflicts(item.dupConflicts));
                this.$set(item, "overlapConflicts", this.dedupeConflicts(item.overlapConflicts));
            });
        },

        checkDecodeDuplicates(candidates) {
            const groups = new Map();
            candidates.forEach((c) => {
                const key = `${c.namePers}_${c.kato}_${c.start}_${c.end}`;
                if (!groups.has(key)) groups.set(key, []);
                groups.get(key).push(c);
            });
            groups.forEach((group) => this.markMutualDuplicates(group));
        },

        markMutualDuplicates(group) {
            if (group.length < 2) return;
            group.forEach((c) => {
                if (!c.ref) return;
                this.$set(c.ref, "isHasDouble", true);
                group.forEach((other) => {
                    if (other === c) return;
                    c.ref.dupConflicts.push({ localCategory: other.localCategory });
                });
            });
        },

        checkDecodeOverlaps(candidates) {
            const groups = new Map();
            candidates.forEach((c) => {
                if (!groups.has(c.namePers)) groups.set(c.namePers, []);
                groups.get(c.namePers).push(c);
            });
            groups.forEach((group) => {
                this.markPairwiseOverlaps(group);
                this.markDateOverloads(group);
            });
        },

        markPairwiseOverlaps(group) {
            for (let i = 0; i < group.length; i++) {
                for (let j = i + 1; j < group.length; j++) {
                    const a = group[i];
                    const b = group[j];
                    if (!(a.start < b.end && b.start < a.end)) continue;
                    const isExactPeriodMatch = a.start === b.start && a.end === b.end;
                    if (isExactPeriodMatch && a.kato === b.kato) continue;
                    this.addOverlapConflict(a, b);
                    this.addOverlapConflict(b, a);
                }
            }
        },

        markDateOverloads(group) {
            const dates = new Set();
            group.forEach((c) => {
                dates.add(c.start);
                dates.add(c.end);
            });
            dates.forEach((date) => {
                const covering = group.filter((c) => c.start <= date && c.end >= date);
                if (covering.length <= 2) return;
                covering.forEach((c) => {
                    covering.forEach((other) => {
                        if (other !== c) this.addOverlapConflict(c, other);
                    });
                });
            });
        },

        addOverlapConflict(target, other) {
            if (!target.ref) return;
            this.$set(target.ref, "isHasOverlap", true);
            target.ref.overlapConflicts.push({
                start: other.start,
                end: other.end,
                localCategory: other.localCategory,
                katoNameRu: other.katoNameRu,
                katoNameKz: other.katoNameKz,
            });
        },

        dedupeConflicts(conflicts) {
            const seen = new Set();
            return conflicts.filter((c) => {
                const key = `${c.localCategory}_${c.start || ""}_${c.end || ""}_${c.katoNameRu || ""}`;
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
        },

        isRentOverLimit(row) {
            if (!row.limit || !row.rent_expense || !row.housing_days) return false;
            return this.safeDecimal(row.rent_expense).greaterThan(this.rentLimitAmount(row));
        },

        rentLimitAmount(row) {
            return this.safeDecimal(row.limit).mul(this.mrp).mul(row.housing_days).toDecimalPlaces(2).toNumber();
        },

        limitTengeAmount(row) {
            return this.safeDecimal(row.limit || 0).mul(this.mrp).toDecimalPlaces(2).toNumber();
        },

        showGoalModal(row) {
            const modal = this.$refs.setGoalModal;
            if (modal) modal.showModal(row);
        },

        onGoalChanged(row) {
            this.$set(row, "rowToSave", true);
            this.setDataChanged(true);
        },

        deleteDecodeRow(row) {
            this.deleteDecodeRows([row], this.getDecText("del_curr_rec"));
        },

        deleteDecodeRows(rows, msg) {
            this.$bvModal
                .msgBoxConfirm(msg, {
                    title: this.getCommonText("confirm"),
                    size: "lg",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: this.getCommonText("yes"),
                    cancelTitle: this.getCommonText("cancel"),
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(async (value) => {
                    if (!value) return;
                    const ids = rows.map((r) => r.id).filter((id) => id > 0);
                    if (ids.length) await this.deleteDecodeIds(ids);
                    const idsToRemove = new Set(rows.map((r) => r.id));
                    this.goodsData = this.goodsData.filter((r) => !idsToRemove.has(r.id));
                    if (!this.goodsData.length) {
                        this.categoryMode = true;
                        this.setDataChanged(false);
                    } else {
                        this.checkDecodeControls();
                    }
                    if (ids.length) {
                        await this.loadCategoryData();
                    }
                })
                .catch((error) => {
                    this.makeToast("danger", this.getErrText("on_del"), error.toString());
                });
        },

        async deleteDecodeIds(ids) {
            try {
                const response = await fetch(
                    "/api-py/delete-list-budget-request-form-01-161-v2/",
                    {
                        method: "DELETE",
                        headers: { "Content-Type": "application/json;charset=utf-8" },
                        body: JSON.stringify({ header: this.header, ids }),
                    }
                );
                if (response.ok) {
                    this.makeToast("success", this.getErrText("msg"), this.getErrText("one_deleted"));
                }
            } catch (error) {
                this.makeToast("danger", this.getErrText("warning"), this.getErrText("on_del"));
            }
        },

        prepareForSaveDecodes(event) {
            if (event) event.preventDefault();
            if (!this.goodsData.length) return;
            if (this.hasDecodeControlViolation) {
                this.makeToast("warning", this.getErrText("not_saved"), this.getErrText("not_valid"));
                return;
            }
            const rowsToSave = this.goodsData.filter((row) => row.rowToSave);
            if (!rowsToSave.length) {
                this.makeToast("warning", this.getErrText("msg"), this.getErrText("not_saved"));
                return;
            }
            const errors = [];
            for (const row of rowsToSave) {
                errors.push(...this.validateDecodeRow(row));
            }
            if (errors.length) {
                errors.forEach((error) => this.makeToast("warning", this.getErrText("not_saved"), error));
                return;
            }
            this.saveDecodes(rowsToSave);
        },

        validateDecodeRow(row) {
            const errors = [];
            if (!row.name_pers || !row.name_pers.trim()) {
                errors.push(this.getFormText("val_name_pers"));
            }
            if (!row.kato) {
                errors.push(this.getFormText("val_kato"));
            }
            if (!row.trip_start_date) {
                errors.push(this.getFormText("val_start_date"));
            }
            if (!row.trip_end_date) {
                errors.push(this.getFormText("val_end_date"));
            }
            if (row.trip_start_date && row.trip_end_date && this.isEndDateInvalid(row)) {
                errors.push(this.getFormText("end_before_start"));
            }
            if (!(row.limit <= 0 || row.housing_days <= 0) && (!row.rent_expense || row.rent_expense <= 0)) {
                errors.push(this.getFormText("val_rent_expense"));
            }
            if (!row.transp_expense || row.transp_expense <= 0) {
                errors.push(this.getFormText("val_transp_expense"));
            }
            if (this.isRentOverLimit(row)) {
                errors.push(this.getErrText("not_valid"));
            }
            return errors;
        },

        async saveDecodes(rows) {
            this.isLoad = true;
            const values = rows.map((row) => ({
                id: row.id,
                post: this.currCategory.post,
                local_category: this.currCategory.local_category,
                limit: row.limit,
                name_pers: row.name_pers,
                kato: row.kato,
                trip_start_date: row.trip_start_date,
                trip_end_date: row.trip_end_date,
                goal_ru: row.goal_ru || null,
                goal_kk: row.goal_kk || null,
                rent_expense: parseFloat(row.rent_expense) || 0,
                transp_expense: parseFloat(row.transp_expense),
                file_hash: row.file_hash || null,
            }));
            try {
                const response = await fetch("/api-py/save-brform01-161_v2/", {
                    method: "POST",
                    headers: { "Content-Type": "application/json;charset=utf-8" },
                    body: JSON.stringify({ header: this.header, values }),
                });
                const result = await response.json();
                if (response.ok && result.result === "success") {
                    if (result.new_ids) {
                        result.new_ids.forEach((ids) => {
                            const savedRow = this.goodsData.find((gd) => gd.id === ids.old_id);
                            if (savedRow) this.$set(savedRow, "id", ids.new_id);
                        });
                    }
                    this.goodsData.forEach((item) => {
                        this.$set(item, "rowToSave", false);
                        this.$set(item, "isNew", false);
                    });
                    this.setDataChanged(false);
                    this.makeToast("success", this.getErrText("msg"), this.getErrText("saved"));
                    await this.loadGoodsData(this.currCategory);
                    await this.loadCategoryData();
                } else {
                    const messages = (result.errors || [])
                        .flatMap((err) => err.messages || [])
                        .map((m) => m[this.lng] || m.ru)
                        .join("; ");
                    this.makeToast("danger", this.getErrText("not_saved"), messages || this.getErrText("bad_data"));
                }
            } catch (e) {
                this.makeToast("danger", this.getErrText("warning"), e.toString());
            } finally {
                this.isLoad = false;
            }
        },

        onNewFileUploaded(item) {
            this.allFiles.push({ ...item, row_id: null });
        },

        onAllFilesClick(item) {
            const label = `${this.postLabel(item.postObj)}. ${this.localCategoryLabel(item.localCategoryObj)}`;
            this.$refs.modalAllFilesManagement.showModal({ ...item, name_ru: label, name_kk: label });
        },
    },
    computed: {
        getFormText() {
            return this.setFormText("form_01_161_v2.");
        },

        dailyNormValue() {
            return this.safeDecimal(this.mrp).mul(2);
        },

        displayedGroups() {
            return [...this.budgetForm, ...this.pendingGroups];
        },

        lastRowFilled() {
            if (!this.pendingGroups.length) return true;
            const last = this.pendingGroups[this.pendingGroups.length - 1];
            return !!(last.post && last.local_category);
        },

        hasDuplicateGroups() {
            return this.displayedGroups.some((g) => g.checkForDuplicates);
        },

        hasDecodeControlViolation() {
            return this.goodsData.some((g) => g.isHasDouble || g.isHasOverlap);
        },

        totalThousandTenge() {
            const sum = this.budgetForm.reduce((acc, row) => acc + (parseFloat(row.total_thousand_tenge) || 0), 0);
            return Math.ceil(sum);
        },

        currCategoryLabel() {
            if (!this.currCategory) return "";
            return this.decodeLabel(this.currCategory.post, this.currCategory.local_category);
        },

        selectableDictPost() {
            return this.dictPost.filter((item) => item.is_actual !== false);
        },

        selectableDictLocalCategory() {
            return this.dictLocalCategory.filter((item) => item.is_actual !== false);
        },

        tableFields() {
            return [
                { key: "selection", label: " " },
                { key: "action", label: " " },
                { key: "post", label: this.getFormText("post") },
                { key: "local_category", label: this.getFormText("local_category") },
                { key: "daily_norm", label: this.getFormText("daily_norm") },
                { key: "housing_norm", label: this.getFormText("housing_norm") },
                { key: "avg_daily_people_days", label: this.getFormText("avg_daily_people_days") },
                { key: "avg_housing_people_days", label: this.getFormText("avg_housing_people_days") },
                { key: "avg_trip_count", label: this.getFormText("avg_trip_count") },
                { key: "avg_transp_cost", label: this.getFormText("avg_transp_cost") },
                { key: "total_thousand_tenge", label: this.getFormText("total_thousand_tenge") },
                { key: "files", label: this.getCommonText("files") },
                { key: "more", label: "" },
            ];
        },
    },
};
</script>
<style scoped>
.filter-actions-flex {
    display: flex;
    gap: 0.5rem;
}

.table-plus {
    border: none;
    background: transparent;
}

.table-plus-disabled {
    pointer-events: none;
    opacity: 0.3;
}

::v-deep tr.b-table-bottom-row {
    font-weight: bold !important;
}

.dup-hint {
    position: relative;
    display: inline-block;
    margin-left: 4px;
}

.dup-hint > i {
    position: static;
}

.dup-hint:hover .pop-up {
    opacity: 1;
    visibility: visible;
}
</style>
